var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcBrandGoogle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFB900",
  d: "m7.04 13.672-3.097 2.315A8.84 8.84 0 0 1 3 11.999a8.84 8.84 0 0 1 .943-3.987l3.097 2.314A5.2 5.2 0 0 0 6.767 12c0 .585.096 1.148.273 1.673"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#00AB47",
  d: "M3.941 15.985C5.44 18.963 8.568 21 12.21 21c4.604 0 8.79-3.273 8.79-9 0-.532-.084-1.105-.21-1.637h-8.58v3.478h4.939c-.46 2.209-2.386 3.477-4.94 3.477-2.418 0-4.458-1.528-5.17-3.653z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF2B25",
  d: "M7.04 10.327c.714-2.121 2.753-3.645 5.168-3.645a5.4 5.4 0 0 1 3.39 1.186l2.68-2.618C16.645 3.86 14.552 3 12.208 3 8.57 3 5.44 5.036 3.942 8.012z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#1F87FC",
  d: "M18.212 18.758C19.902 17.223 21 14.933 21 12c0-.532-.084-1.105-.21-1.637h-8.58v3.478h4.94c-.248 1.185-.917 2.1-1.878 2.693z"
})));
export default SvgIcBrandGoogle;